import React from 'react';
import { motion } from 'framer-motion';
import { Film, Play } from 'lucide-react';
import { DEMO_LIBRARY_VIDEO_THUMB } from './demoStockImages';

/**
 * Library video file card — matches app VideoCard thumb strip (not a draft/planning card).
 */
export function VideoAssetCard({
  title = 'Brand interview',
  duration = '2:14',
  meta = 'Source file in library',
  thumbnailUrl = DEMO_LIBRARY_VIDEO_THUMB,
  compact = false,
  showLibraryBadge = false,
  badgeLabel = 'Library video',
  badgeIcon: BadgeIcon = Film,
  badgeTone = 'library',
  showPlay = true,
  showDuration = true,
  thumbOverlayIcon: ThumbOverlayIcon,
  thumbnailLoading,
  onClick,
  interactive = false,
  className = '',
}) {
  const Wrapper = interactive ? motion.button : 'div';
  const cardClassName = [
    'mkt-video-asset-card',
    interactive ? 'mkt-video-asset-card--interactive' : '',
    compact ? 'mkt-video-asset-card--compact' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const wrapperProps = interactive
    ? {
        type: 'button',
        onClick,
        whileTap: { scale: 0.97 },
        className: cardClassName,
      }
    : {
        className: cardClassName,
      };

  return (
    <Wrapper {...wrapperProps}>
      {!compact || showLibraryBadge ? (
        <div className="mkt-video-asset-card-badges">
          <span
            className={`mkt-video-asset-card-badge mkt-video-asset-card-badge--${badgeTone}`}
          >
            <BadgeIcon className="ui-icon-xs" aria-hidden />
            {badgeLabel}
          </span>
        </div>
      ) : null}
      <div className="mkt-video-asset-card-thumb">
        {thumbnailUrl ? (
          <img
            src={thumbnailUrl}
            alt=""
            className="mkt-video-asset-card-thumb-img"
            loading={thumbnailLoading || (compact ? 'eager' : 'lazy')}
            decoding="async"
          />
        ) : (
          <div className="mkt-video-asset-card-thumb-gradient" aria-hidden />
        )}
        {showPlay ? (
          <Play
            className="mkt-video-asset-card-play"
            fill="rgba(255,255,255,0.35)"
            color="rgba(255,255,255,0.9)"
            aria-hidden
          />
        ) : null}
        {ThumbOverlayIcon ? (
          <ThumbOverlayIcon
            className="mkt-video-asset-card-thumb-overlay-icon"
            aria-hidden
          />
        ) : null}
        {showDuration && duration ? (
          <span className="mkt-video-asset-card-duration">{duration}</span>
        ) : null}
      </div>
      <div className="mkt-video-asset-card-body">
        <p className="mkt-video-asset-card-title">{title}</p>
        {!compact && meta ? <p className="mkt-video-asset-card-meta">{meta}</p> : null}
      </div>
    </Wrapper>
  );
}
